import {
  IconButton,
  Checkbox,
  HStack,
  Text,
  Flex,
  Box,
  useColorModeValue,
} from "@chakra-ui/react";
import { FC, useMemo } from "react";
import Highlighter from "react-highlight-words";

import { ITableGridRow } from "Interfaces/Components/TableGrid";
import useTable from "hooks/use-table";
import useSchedule from "hooks/use-schedule";

const TableGridItemScheduleDrawer: FC<{ [key: string]: any }> = ({ data }) => {
  const { actions, columns, query } = useTable();
  const { handleUpdateWanted, setSelectIdDate, idSelectDate } = useSchedule();
  const handleBlur = (e: string | number) => {
    handleUpdateWanted(data["pedido-id"], Number(e));
  };
  const textColor = useColorModeValue("black", "black");

  const rows = useMemo<ITableGridRow[]>(() => {
    const res = [];
    for (const column of columns) {
      if (column.columns && column.columns.length > 0) {
        for (const row of column.columns) {
          res.push({
            id: row.id,
            value: data[row.id],
            align: row.align || "left",
          });
        }
      } else {
        res.push({
          id: column.id!,
          value: data[column.canPrint ? column.id! : column.group],
          align: column.align || "left",
        });
      }
    }
    return res;
  }, [columns, data]);

  return (
    <tr>
      <td>
        <HStack
          spacing={2}
          w="100%"
          alignItems="center"
          justifyContent="center"
        >
          <Checkbox
            key={`table-action-1}`}
            colorScheme="yellow"
            isChecked={idSelectDate === data["pedido-id"]}
            borderColor="blackAlpha.400"
            alignItems="center"
            isDisabled={
              idSelectDate !== 0 && idSelectDate !== data["pedido-id"]
            }
            onChange={() => {
              setSelectIdDate(
                idSelectDate === data["pedido-id"] ? 0 : data["pedido-id"]
              );
            }}
          />
        </HStack>
      </td>
      {rows.map(({ id, value, align }, key) => (
        <td
          key={`${id}-${key}`}
          align={align || "left"}
          style={{
            position: "relative",
            padding: id === "quantidade-agendada" && 0,
            background: id === "quantidade-agendada" && "#FEFFC7",
          }}
        >
          {(() => {
            if (id === "quantidade-agendada") {
              return (
                <>
                  <Flex>
                    <Box
                      width={100}
                      contentEditable={true}
                      onBlurCapture={(e) =>
                        handleBlur(e.currentTarget.textContent)
                      }
                      color={textColor}
                      onKeyDown={(e) => {
                        if (
                          e.keyCode === 46 ||
                          e.keyCode === 8 ||
                          (e.keyCode > 95 && e.keyCode < 106) ||
                          e.keyCode === 37 ||
                          e.keyCode === 39
                        ) {
                          // let it happen, don't do anything
                        } else {
                          // Ensure that it is a number and stop the keypress
                          if (e.keyCode < 48 || e.keyCode > 57) {
                            // eslint-disable-next-line no-restricted-globals
                            event.preventDefault();
                          }
                        }
                        if (e.key === "-") {
                          e.preventDefault();
                        }
                        if (e.key === "Enter") {
                          e.preventDefault();
                          handleBlur(e.currentTarget.textContent);
                        }
                      }}
                      css={{
                        paddingLeft: 12,
                      }}
                    >
                      {String(value).substring(0, 1000)}
                    </Box>
                  </Flex>
                </>
              );
            } else {
              return (
                <div className="body__th-value" color="black">
                  {query.length > 0 ? (
                    <Highlighter
                      searchWords={String(query).split(" ")}
                      textToHighlight={String(value)}
                      color={textColor}
                    />
                  ) : (
                    <Text color={textColor}>{value}</Text>
                  )}
                </div>
              );
            }
          })()}
        </td>
      ))}
    </tr>
  );
};

export default TableGridItemScheduleDrawer;
